module.exports = __webpack_public_path__ + "img/minus.f97377f4.svg";